// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.headline[data-v-14ccdaaa] {\n  color: #006c27;\n  font-size: 1rem !important;\n}\n.link[data-v-14ccdaaa] {\n  color: #006c27;\n  background-color: transparent;\n  text-decoration: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
